import React from 'react';
import '../template-file-css/document-file-template.css';



export const HFI_EapIntakeInformationForm = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='HFI_EapIntakeInformationForm' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'><center><h3>EAP INTAKE INFORMATION</h3></center></p>

                <table>
                    <tr>
                        <td className='w-450'>
                            <span className='eleHeader'>Person Served Name:</span></td>
                        <td className='w-150'>
                            <span className='eleHeader'>Date of Birth</span></td>
                        <td className='w-150'>
                            <span className='eleHeader'>Record #</span></td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <input type='text' id='txtPersonServedName' name='txtPersonServedName' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtDateBirth' name='txtDateBirth' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtRecord' name='txtRecord' className='add-only' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>First Appointment Date: </span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>EAP Auth# </span></td>
                        <td className='w-250'>
                            <span className='eleHeader'># Approved Sessions </span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='date' id='txtFirstAppointmentDate' name='txtFirstAppointmentDate' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtAuth' name='txtAuth' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtApprovedSessions' name='txtApprovedSessions' className='add-only' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Address:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>City:</span></td>

                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtAddress' name='txtAddress' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtCity' name='txtCity' className='add-only' /></td>

                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>State:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>ZIP:</span></td>

                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtState' name='txtState' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtZip' name='txtZip' className='add-only' /></td>

                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Do we have permission to contact you at the above address?</span>
                    <input type='radio' id='rbDoWeHavePermission_Yes' name='rbDoWeHavePermission' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbDoWeHavePermission_No' name='rbDoWeHavePermission' className='add-only' value='No' /> No
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Work Number:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtWorkNumber' name='txtWorkNumber' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-375'><b>May we call you at this number?</b> &nbsp;&nbsp;
                            <input type='radio' id='rbCallThisNumber_Yes' name='rbCallThisNumber' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbCallThisNumber_No' name='rbCallThisNumber' className='add-only' value='No' /> No
                        </td>
                        <td className='w-375'><b>May we leave a message?</b>&nbsp;&nbsp;
                            <input type='radio' id='rbLeaveMessage_Yes' name='rbLeaveMessage' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbLeaveMessage_No' name='rbLeaveMessage' className='add-only' value='No' /> No
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Home Number:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtHomeNumber' name='txtHomeNumber' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-375'><b>May we call you at this number?</b> &nbsp;&nbsp;
                            <input type='radio' id='rbCallThisNumber1_Yes' name='rbCallThisNumber1' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbCallThisNumber1_No' name='rbCallThisNumber1' className='add-only' value='No' /> No
                        </td>
                        <td className='w-375'><b>May we leave a message?</b>&nbsp;&nbsp;
                            <input type='radio' id='rbLeaveMessage1_Yes' name='rbLeaveMessage1' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbLeaveMessage1_No' name='rbLeaveMessage1' className='add-only' value='No' /> No
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Emergency Number:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtEmergencyNumber' name='txtEmergencyNumber' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-375'><b>May we call you at this number?</b> &nbsp;&nbsp;
                            <input type='radio' id='rbCallThisNumber2_Yes' name='rbCallThisNumber2' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbCallThisNumber2_No' name='rbCallThisNumber2' className='add-only' value='No' /> No
                        </td>
                        <td className='w-375'><b>May we leave a message?</b>&nbsp;&nbsp;
                            <input type='radio' id='rbLeaveMessage2_Yes' name='rbLeaveMessage2' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbLeaveMessage2_No' name='rbLeaveMessage2' className='add-only' value='No' /> No
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Name of Employer or Organization through which you are accessing EAP Services:</span>
                    <input type='text' id='txtNameOfEmployer' name='txtNameOfEmployer' className='add-only' /></p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Employer's Name:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Employee's Job Title </span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Length of service:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtEmployerName' name='txtEmployerName' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtEmployeeJobTitle' name='txtEmployeeJobTitle' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtLengthOfService' name='txtLengthOfService' className='add-only' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Your Status:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbYourStatus_Employee' name='rbYourStatus' className='add-only' value='Employee' /> Employee
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbYourStatus_Spouse' name='rbYourStatus' className='add-only' value='EmployeeSpouse' /> Employee Spouse
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbYourStatus_Child' name='rbYourStatus' className='add-only' value='EmployeeChild' /> Employee Child
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbYourStatus_Retiree' name='rbYourStatus' className='add-only' value='Retiree' /> Retiree
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbYourStatus_Retiree' name='rbYourStatus' className='add-only' value='RetireeSpouse' /> Retiree Spouse
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbYourStatus_RetireeChild' name='rbYourStatus' className='add-only' value='RetireeChild' /> Retiree Child
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbYourStatus_Other' name='rbYourStatus' className='add-only' value='Other' /> Other &nbsp;
                            <input type='text' id='txtYourStatus_Other' name='txtYourStatus_Other' className='add-only w-375 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Do you have health coverage?</span>
                    <input type='radio' id='rbDoYouHaveHealthCoverage_Yes' name='rbDoYouHaveHealthCoverage' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbDoYouHaveHealthCoverage_No' name='rbDoYouHaveHealthCoverage' className='add-only' value='No' /> No <br />
                    <span className='eleHeader'>(if Yes) Name of Organization(s) through which you are covered:</span>
                    <input type='text' id='txtIfYesWhichCovered' name='txtIfYesWhichCovered' className='add-only' />
                </p>


                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>How did you access the EAP?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbHowDidYouAccess_Self' name='rbHowDidYouAccess' className='add-only' value='SelfReferral' /> Self-Referral
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbHowDidYouAccess_Family' name='rbHowDidYouAccess' className='add-only' value='EmployeeFamilyInitiated' /> Family Initiated
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbHowDidYouAccess_Primary' name='rbHowDidYouAccess' className='add-only' value='PrimaryReferral' /> Primary Care Physician Referral
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbHowDidYouAccess_Medical' name='rbHowDidYouAccess' className='add-only' value='Medical' /> Medical Department Referral/Human Resources
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbHowDidYouAccess_Supervisor' name='rbHowDidYouAccess' className='add-only' value='SupervisorSpouse' /> Supervisor Recommendation (Informal)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbHowDidYouAccess_Formal' name='rbHowDidYouAccess' className='add-only' value='Formal' /> Supervisor Referral (Formal)
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbHowDidYouAccess_Mandatory' name='rbHowDidYouAccess' className='add-only' value='MandatorySpouse' /> Mandatory Supervisor Referral
                        </td>

                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbHowDidYouAccess_Other' name='rbHowDidYouAccess' className='add-only' value='Other' /> Other &nbsp;
                            <input type='text' id='txtHowDidYouAccess_Other' name='txtHowDidYouAccess_Other' className='add-only w-375 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Were you referred for a work performance problem? </span>
                    <input type='radio' id='rbWereyouReferredFor_Yes' name='rbWereyouReferredFor' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbWereyouReferredFor_No' name='rbWereyouReferredFor' className='add-only' value='No' /> No
                </p>


                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>If yes, please indicate the type:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbPleaseIndicateType_Absenteeism' name='rbPleaseIndicateType' className='add-only' value='AbsenteeismTardiness' /> Absenteeism/Tardiness
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbPleaseIndicateType_Safety' name='rbPleaseIndicateType' className='add-only' value='SafetySecurity' /> Safety/Security
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbPleaseIndicateType_Work' name='rbPleaseIndicateType' className='add-only' value='WorkRelationships' /> Work Relationships
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbPleaseIndicateType_Quantity' name='rbPleaseIndicateType' className='add-only' value='Quantity' /> Quantity/Quality of Work
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbPleaseIndicateType_Positive' name='rbPleaseIndicateType' className='add-only' value='Positive' /> Positive Alcohol/Drug Test
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbPleaseIndicateType_Other' name='rbPleaseIndicateType' className='add-only' value='Other' /> Other &nbsp;
                            <input type='text' id='txtPleaseIndicateType_Other' name='txtPleaseIndicateType_Other' className='add-only w-375 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>What Concerns brought you to the EAP?</span>
                    <textarea id='txtWhatConcernsBrought' name='txtWhatConcernsBrought' className='add-only'></textarea>
                </p>


                <p className='w-750'><span className='eleHeader'>What do you want to see happen as a result of coming here (Goal)?</span>
                    <textarea id='txtWhatDoYouWantHappenComingHere' name='txtWhatDoYouWantHappenComingHere' className='add-only'></textarea>
                </p>


                <p className='w-750'><span className='eleHeader'>What have you tried on your own to solve your concerns?</span>
                    <textarea id='txtWhatHaveTriedSolveYourConcerns' name='txtWhatHaveTriedSolveYourConcerns' className='add-only'></textarea>
                </p>


                <p className='w-750'><span className='eleHeader'>Have you had thoughts of self-harm </span>
                    <input type='radio' id='rbHaveYouHadThoughts_Yes' name='rbHaveYouHadThoughts' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbHaveYouHadThoughts_No' name='rbHaveYouHadThoughts' className='add-only' value='No' /> No
                </p>


                <p className='w-750'><span className='eleHeader'>Have you had thoughts of harming others </span>
                    <input type='radio' id='rbHaveYouHadThoughtsOther_Yes' name='rbHaveYouHadThoughtsOther' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbHaveYouHadThoughtsOther_No' name='rbHaveYouHadThoughtsOther' className='add-only' value='No' /> No
                </p>


                <p className='w-750'>
                    <h4>Healthy Habit Information(please base your answers on the past month):</h4>
                </p>

                <p className='w-750'><span className='eleHeader'>Have you participated in regular exercise/sports/recreation (about 3 times/week) to keep fit? </span>
                    <input type='radio' id='rbHaveYouParticipatedRegular_Yes' name='rbHaveYouParticipatedRegular' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbHaveYouParticipatedRegular_No' name='rbHaveYouParticipatedRegular' className='add-only' value='No' /> No
                </p>

                <p className='w-750'><span className='eleHeader'>Have you been dieting to lose weight?</span>
                    <input type='radio' id='rbHaveYouBeenDieting_Yes' name='rbHaveYouBeenDieting' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbHaveYouBeenDieting_No' name='rbHaveYouBeenDieting' className='add-only' value='No' /> No
                </p>

                <p className='w-750'><span className='eleHeader'>Have you smoked cigarettes on a daily basis?</span>
                    <input type='radio' id='rbHaveYouSmokedCigarettes_Yes' name='rbHaveYouSmokedCigarettes' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbHaveYouSmokedCigarettes_No' name='rbHaveYouSmokedCigarettes' className='add-only' value='No' /> No
                </p>


                <p className='w-750'>
                    <h4>How Often in the past month did you drink alcohol?</h4>
                </p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbHowOftenDrinkAlcohol_1' name='rbHowOftenDrinkAlcohol' className='add-only' value='IDoNotDrink' /> I do not drink at all
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbHowOftenDrinkAlcohol_2' name='rbHowOftenDrinkAlcohol' className='add-only' value='AboutOnceMonth' /> About once a month
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbHowOftenDrinkAlcohol_3' name='rbHowOftenDrinkAlcohol' className='add-only' value='TimesMonth' /> 2 to 3 times a month
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbHowOftenDrinkAlcohol_4' name='rbHowOftenDrinkAlcohol' className='add-only' value='TimesWeek' /> 2 to 3 times a week
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbHowOftenDrinkAlcohol_5' name='rbHowOftenDrinkAlcohol' className='add-only' value='DayOrMore' /> Once a day or more
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>

                <p className='w-750'><h4>OPTIONAL</h4></p>

                <p className='w-750'><span className='eleHeader'>Education (Years completed or degree earned):</span>
                    <textarea id='txtEducationYearCompleted' name='txtEducationYearCompleted' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>Legal Issues:</span>
                    <input type='radio' id='rbLegalIssues_Yes' name='rbLegalIssues' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbLegalIssues_No' name='rbLegalIssues' className='add-only' value='No' /> No
                </p>

                <p className='w-750'><span className='eleHeader'>Financial Problems:</span>
                    <input type='radio' id='rbFinancialProblems_Yes' name='rbFinancialProblems' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbFinancialProblems_No' name='rbFinancialProblems' className='add-only' value='No' /> No
                </p>

                <p className='w-750'><span className='eleHeader'>Military Service: </span>
                    <input type='radio' id='rbMilitaryService_Yes' name='rbMilitaryService' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbMilitaryService_No' name='rbMilitaryService' className='add-only' value='No' /> No
                    <br /><br />

                    <input type='radio' id='rbMilitaryService1_Present' name='rbMilitaryService1' className='add-only' value='Present' /> Present &nbsp;
                    <input type='radio' id='rbMilitaryService1_Past' name='rbMilitaryService1' className='add-only' value='Past' /> Past Branch(es):
                    <input type='text' id='txtMilitaryService' name='txtMilitaryService' className='add-only w-375 custom-add-only' />
                </p>


                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp;</td>
                        <td className='signature w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Person Served Signature</td>
                        <td className='small w-250'>Date</td>
                    </tr>
                </table>







            </div>
        </form >

    )
}  
